import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronDownIcon, MenuIcon, PhoneIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
import { CONTACT } from '../data/modalities';
const PRODUCT_LINKS = [{
  label: 'Class IV Laser',
  href: '#category-class-iv-laser'
}, {
  label: 'Shockwave',
  href: '#category-shockwave'
}, {
  label: 'High Energy Inductive Therapy',
  href: '#category-high-energy-inductive-therapy'
}, {
  label: 'Whole Body Red Light / LED Therapy',
  href: '#category-whole-body-red-light-led-therapy'
}, {
  label: 'Thermal Imaging',
  href: '#category-thermal-imaging'
}, {
  label: 'Deep Oscillation',
  href: '#category-deep-oscillation'
}, {
  label: 'Used Equipment',
  href: '#category-used-equipment'
}, {
  label: 'Concierge Modality Suite',
  href: '#category-concierge-modality-suite'
}, {
  label: 'Neuro Reformer',
  href: '#category-neuro-reformer'
}, {
  label: 'RegenMedix',
  href: '#category-regenmedix'
}];
const NAV = [{
  label: 'Concierge Suite',
  href: '#concierge'
}, {
  label: 'Used Equipment',
  href: '#used-equipment'
}, {
  label: 'About',
  to: '/about'
}, {
  label: 'Contact',
  to: '/contact'
}];
export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [desktopProductsOpen, setDesktopProductsOpen] = useState(false);
  const [mobileProductsOpen, setMobileProductsOpen] = useState(false);
  const location = useLocation();
  function closeAllMenus() {
    setMobileMenuOpen(false);
    setDesktopProductsOpen(false);
    setMobileProductsOpen(false);
  }
  function handleSamePageAnchorClick(event: React.MouseEvent<HTMLAnchorElement>, hash: string) {
    event.preventDefault();
    const target = document.querySelector(hash);
    if (!target) return;
    closeAllMenus();
    window.history.pushState(null, '', hash);
    window.setTimeout(() => {
      const header = document.querySelector('header');
      const headerHeight = header ? header.getBoundingClientRect().height : 0;
      const targetTop = target.getBoundingClientRect().top + window.scrollY;
      const top = Math.max(0, targetTop - headerHeight - 20);
      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }, 50);
  }
  return <header className="sticky top-0 z-50 w-full border-b border-white/15 bg-navy text-white shadow-[0_8px_24px_-16px_rgba(9,10,42,0.8)]" data-id="element-55" data-mp="18n3ckgxvwug9">
      <div className="mx-auto flex h-[82px] max-w-7xl items-center justify-between px-5 sm:px-8 xl:px-3" data-id="element-56" data-mp="1cpq8asxoeziq">
        <Link to="/" aria-label="JAG Medical Solutions home" onClick={closeAllMenus} className="rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light focus-visible:ring-offset-2 focus-visible:ring-offset-navy" data-id="element-57" data-mp="ypxj521ssrcv">
          <Logo data-id="element-58" data-mp="2y0yqs5ll0v7r" />
        </Link>

        <nav className="hidden items-center gap-3 xl:flex" aria-label="Primary" data-id="element-59" data-mp="2xzxe5wox40nx">
          <Link to="/" className={`relative py-2 text-[15px] font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light focus-visible:ring-offset-2 focus-visible:ring-offset-navy ${location.pathname === '/' && !location.hash ? 'text-teal-light' : 'text-white/80 hover:text-teal-light'}`} data-id="element-60" data-mp="mf69kmz3ew3w">
            Home
            {location.pathname === '/' && !location.hash && <span className="absolute bottom-0 left-0 h-0.5 w-full bg-teal" data-id="element-61" data-mp="106bbjvpxo0he" />}
          </Link>

          <div className="group relative" onMouseLeave={() => setDesktopProductsOpen(false)} onKeyDown={event => {
          if (event.key === 'Escape') setDesktopProductsOpen(false);
        }} data-id="element-62" data-mp="1f3lnt7aehae6">
            <button type="button" aria-controls="desktop-products-menu" aria-expanded={desktopProductsOpen} aria-haspopup="menu" onClick={() => setDesktopProductsOpen(value => !value)} className={`inline-flex items-center gap-1.5 py-2 text-[15px] font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light focus-visible:ring-offset-2 focus-visible:ring-offset-navy ${desktopProductsOpen ? 'text-teal-light' : 'text-white/80 hover:text-teal-light'}`} data-id="element-63" data-mp="3gwt2qfm3ppzj">
              Products
              <ChevronDownIcon className={`h-4 w-4 transition-transform ${desktopProductsOpen ? 'rotate-180' : ''}`} data-id="element-64" data-mp="1p7a8us23wxsr" />
            </button>

            <div id="desktop-products-menu" className={`invisible pointer-events-none absolute left-0 top-full z-[60] mt-1 w-[360px] origin-top rounded-lg border border-white/15 bg-navy p-2 opacity-0 shadow-2xl shadow-black/35 transition-[opacity,transform,visibility] duration-150 group-hover:visible group-hover:pointer-events-auto group-hover:opacity-100 group-focus-within:visible group-focus-within:pointer-events-auto group-focus-within:opacity-100 ${desktopProductsOpen ? 'visible pointer-events-auto opacity-100' : ''}`} role="menu" aria-label="Products" data-id="element-65" data-mp="1t7kjii0ugcdy">
              <div className="grid gap-0.5" data-id="element-66" data-mp="k0984lh84s41">
                {PRODUCT_LINKS.map(item => <a key={item.href} href={item.href} onClick={event => handleSamePageAnchorClick(event, item.href)} className="whitespace-nowrap rounded-md px-3 py-2 text-[15px] font-medium text-white/85 transition-colors hover:bg-white/10 hover:text-teal-light focus-visible:outline-none focus-visible:bg-white/10 focus-visible:text-teal-light" role="menuitem" data-id="element-67" data-mp="f0mjzgzuxrgg">
                    {item.label}
                  </a>)}
              </div>
              <div className="my-2 border-t border-white/15" data-id="element-68" data-mp="3dsu9jof4le3u" />
              <a href="#product-of-the-month" onClick={event => handleSamePageAnchorClick(event, '#product-of-the-month')} className="block rounded-md px-3 py-2 text-[15px] font-semibold text-teal-light transition-colors hover:bg-white/10 focus-visible:outline-none focus-visible:bg-white/10" role="menuitem" data-id="element-69" data-mp="3dvgerhejnhiw">
                Product of the Month
              </a>
            </div>
          </div>

          {NAV.map(item => {
          const className = `relative py-2 text-[15px] font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light focus-visible:ring-offset-2 focus-visible:ring-offset-navy ${location.pathname === item.to ? 'text-teal-light' : 'text-white/80 hover:text-teal-light'}`;
          const activeIndicator = item.to && location.pathname === item.to && <span className="absolute bottom-0 left-0 h-0.5 w-full bg-teal" data-id="element-70" data-mp="28sm9ih8d2c1a" />;
          return item.href ? <a key={item.href} href={item.href} onClick={event => handleSamePageAnchorClick(event, item.href)} className={className} data-id="element-71" data-mp="23t9ntzt87b0a">
                {item.label}
              </a> : <Link key={item.to} to={item.to ?? '/'} className={className} data-id="element-72" data-mp="1pvl1enjifvt4">
                {item.label}
                {activeIndicator}
              </Link>;
        })}
        </nav>

        <div className="flex items-center gap-3" data-id="element-73" data-mp="1yxc91xxm2cpm">
          <a href={CONTACT.phoneHref} className="hidden items-center gap-2 rounded-full bg-teal px-5 py-2.5 text-[15px] font-semibold text-white transition-colors hover:bg-teal-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-navy sm:inline-flex" data-id="element-74" data-mp="1utwc10hmqace">
            <PhoneIcon className="h-4 w-4" data-id="element-75" data-mp="13l2xc6s8vlk2" />
            Call {CONTACT.phone}
          </a>
          <button type="button" className="inline-flex h-10 w-10 items-center justify-center rounded-lg text-white transition-colors hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light focus-visible:ring-offset-2 focus-visible:ring-offset-navy xl:hidden" onClick={() => setMobileMenuOpen(value => !value)} aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'} aria-expanded={mobileMenuOpen} data-id="element-76" data-mp="18jwd65v07one">
            {mobileMenuOpen ? <XIcon className="h-6 w-6" data-id="element-77" data-mp="21axx0k9n68d9" /> : <MenuIcon className="h-6 w-6" data-id="element-78" data-mp="218bnwg73rksx" />}
          </button>
        </div>
      </div>

      {mobileMenuOpen && <div className="border-t border-white/15 bg-navy xl:hidden" data-id="element-79" data-mp="6w53cqsbjrny">
          <nav className="mx-auto flex max-w-7xl flex-col px-5 py-3 sm:px-8" aria-label="Mobile" data-id="element-80" data-mp="2k6wodb94hh3t">
            <Link to="/" onClick={closeAllMenus} className="border-b border-white/10 py-3 text-[15px] font-medium text-white/85 transition-colors hover:text-teal-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light focus-visible:ring-inset" data-id="element-81" data-mp="2ffy460l0jyva">
              Home
            </Link>

            <div className="border-b border-white/10" data-id="element-82" data-mp="2z4797b7nnzc7">
              <button type="button" onClick={() => setMobileProductsOpen(value => !value)} aria-expanded={mobileProductsOpen} className="flex w-full items-center justify-between py-3 text-left text-[15px] font-medium text-white/85 transition-colors hover:text-teal-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light focus-visible:ring-inset" data-id="element-83" data-mp="2z4p2byz0txfw">
                Products
                <ChevronDownIcon className={`h-4 w-4 transition-transform ${mobileProductsOpen ? 'rotate-180' : ''}`} data-id="element-84" data-mp="1d3z1wf1bkh7v" />
              </button>
              {mobileProductsOpen && <div className="mb-3 rounded-lg border border-white/10 bg-white/[0.05] p-2" data-id="element-85" data-mp="1mua8688h72hx">
                  {PRODUCT_LINKS.map(item => <a key={item.href} href={item.href} onClick={event => handleSamePageAnchorClick(event, item.href)} className="block rounded-md px-3 py-2.5 text-sm font-medium text-white/80 hover:bg-white/10 hover:text-teal-light focus-visible:outline-none focus-visible:bg-white/10" data-id="element-86" data-mp="1vtf89izor3w7">
                      {item.label}
                    </a>)}
                  <div className="my-1.5 border-t border-white/15" data-id="element-87" data-mp="6f8zx0k014gn" />
                  <a href="#product-of-the-month" onClick={event => handleSamePageAnchorClick(event, '#product-of-the-month')} className="block rounded-md px-3 py-2.5 text-sm font-semibold text-teal-light hover:bg-white/10 focus-visible:outline-none focus-visible:bg-white/10" data-id="element-88" data-mp="2i1ua8hcixuk6">
                    Product of the Month
                  </a>
                </div>}
            </div>

            {NAV.map(item => item.href ? <a key={item.href} href={item.href} onClick={event => handleSamePageAnchorClick(event, item.href)} className="border-b border-white/10 py-3 text-[15px] font-medium text-white/85 transition-colors hover:text-teal-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light focus-visible:ring-inset" data-id="element-89" data-mp="23atstmtsuqbw">
                  {item.label}
                </a> : <Link key={item.to} to={item.to ?? '/'} onClick={closeAllMenus} className="border-b border-white/10 py-3 text-[15px] font-medium text-white/85 transition-colors hover:text-teal-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light focus-visible:ring-inset" data-id="element-90" data-mp="3i9hhmqc4cpks">
                  {item.label}
                </Link>)}
            <a href={CONTACT.phoneHref} onClick={closeAllMenus} className="mt-4 inline-flex items-center justify-center gap-2 rounded-full bg-teal px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-teal-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-91" data-mp="4ea6yyok1h7">
              <PhoneIcon className="h-4 w-4" data-id="element-92" data-mp="nsfge18dz5tg" />
              Call {CONTACT.phone}
            </a>
          </nav>
        </div>}
    </header>;
}